import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "test-start-countdown is-show",
  id: "js-test-start-countdown"
}
const _hoisted_2 = { class: "test-start-countdown__body" }
const _hoisted_3 = { id: "js-test-start-countdown-scale" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("問題"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "もんだい"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("を"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("開始"),
    /*#__PURE__*/_createElementVNode("rp", null, "（"),
    /*#__PURE__*/_createElementVNode("rt", null, "かいし"),
    /*#__PURE__*/_createElementVNode("rp", null, "）")
  ]),
  /*#__PURE__*/_createTextVNode("します")
], -1)
const _hoisted_5 = { class: "test-start-countdown__number" }
const _hoisted_6 = {
  class: "count",
  id: "js-test-start-countdown-number"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "520",
  height: "520",
  class: "test-start-count-circle is-animation-start",
  id: "js-test-start-count"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "250",
    cy: "250",
    r: "220"
  })
], -1)

import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Countdown',
  setup(__props) {

const started = ref(false);
const countdown = ref<number>(3);

const start = () => {
  started.value = true;
  const countUp = () => { countdown.value = countdown.value - 1; }
  const intervalId = setInterval(() => {
    countUp();
    if (countdown.value == 0) {
      clearInterval(intervalId);
      started.value = false;
      countdown.value = 0;
    }
  }, 1000);
}
start();


return (_ctx: any,_cache: any) => {
  return (started.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(countdown.value), 1),
              _hoisted_7
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})